module.exports = __webpack_public_path__ + "img/denis_1.a40933da.jpg";